<template>
  <div class="app-main-content">
    <div class="grid-view">
      <div class="main-content">
        <div class="section operations" style="height: 39px;">
          <div class="triggers">
            <div>
              <span style="width: 100px;color: #333333">{{ this.$t('CargoMsg.Cargo_GroupScene') }}</span>
              <el-select v-model="searchConditions.groupScene" style="width:200px;padding-left:20px;">
                <el-option
                  v-for="(item,index) in SystemConstants.GROUP_SCENE_LIST"
                  :key="index"
                  :label="$store.getters.language==='zh'?item.chineseName:item.englishName"
                  :value="item.code"
                />
              </el-select>
              <span style="padding-left:10px;width: 100px;color: #333333">{{ this.$t('CargoMsg.Cargo_GroupName') }}</span>
              <el-input v-model="searchConditions.groupName" style="width:200px;padding-left:20px;" clearable />
              <el-button type="primary" size="mini" @click="fetchList">{{ $t('common.btn.query') }}</el-button>
              <el-button type="primary" size="mini" @click="toLook">{{ $t('CargoMsg.Cargo_View') }}</el-button>
              <el-button v-show="$checkPermission(['button_MailGroup_add'])" type="primary" size="mini" @click="toSaveOrEdit(true)">{{ $t('common.btn.new') }} </el-button>
              <el-button v-show="$checkPermission(['button_MailGroup_edit'])" type="primary" size="mini" @click="toSaveOrEdit(false)">{{ $t('common.btn.edit') }} </el-button>
              <el-button v-show="$checkPermission(['button_MailGroup_delete'])" type="danger" size="mini" @click="toDelete">{{ $t('common.btn.delete') }} </el-button>
            </div>
          </div>
        </div>
        <div class="section grid-wrapper" style="min-height:350px">
          <cargo-ag-grid
            config-module="100901"
            :grid-params.sync="gridParams"
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :row-data="rowData"
            @gridReady="onGridReady"
          />
        </div>
        <div class="pagination-wrapper">
          <cargo-pagination
            v-show="searchConditions.total>0"
            config-module="100901"
            :total="searchConditions.total"
            :page.sync="searchConditions.pageNum"
            :limit.sync="searchConditions.pageSize"
            @pagination="fetchList"
          />
        </div>
      </div>
    </div>
    <!-- 邮件群组新增或维护 -->
    <el-dialog
      v-if="isShowMaintain"
      v-el-drag-dialog
      :close-on-click-modal="false"
      class="dialog"
      :visible.sync="isShowMaintain"
      :title="maintainTitle"
      width="600px"
    >
      <el-form ref="mailGroupForm" :disabled="isEdit" label-width="60px" label-position="right">
        <el-row>
          <el-col :span="12">
            <el-form-item :label="$t('CargoMsg.Cargo_GroupScene')">
              <el-checkbox v-model="mailGroupForm.groupSceneTo">{{ $t('CargoMsg.Cargo_Receiver2') }}</el-checkbox>
              <el-checkbox v-model="mailGroupForm.groupSceneCc">{{ $t('CargoMsg.Cargo_CcPerson') }}</el-checkbox>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('CargoMsg.Cargo_GroupType')">
              <el-radio-group v-model="mailGroupForm.groupType">
                <el-radio :label="0">{{ $t('CargoMsg.Cargo_Common') }}</el-radio>
                <el-radio :label="1">{{ $t('CargoMsg.Cargo_Personal') }}</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item :label="$t('CargoMsg.Cargo_GroupName')">
              <el-input v-model="mailGroupForm.groupName" :maxlength="50" size="mini" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item :label="$t('SeaExport.Email')">
              <div class="lookText">
                <el-input v-model="mailGroupForm.emailAddress" type="textarea" :maxlength="500" :rows="10" size="mini" @blur="handleAddress" />
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer">
        <el-button v-show="!this.isEdit" size="mini " type="primary" @click="saveOrEdit">{{ $t('common.btn.save') }}</el-button>
        <el-button v-show="this.isEdit" type="primary" size="mini" @click="toSaveOrEdit(false)">{{ $t('common.btn.edit') }} </el-button>
        <el-button size="mini " @click="cancelSaveOrEdit">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import URL from '@/api/urlTranslator'
import { getMailGroupList, addMailGroup, editMailGroup, deleteMailGroup } from '@/api/basicData/mailGroup'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import ColumnUtils from '@/utils/ColumnUtils'
import StrUtils from '@/utils/StrUtils'

export default {
  name: 'MailGroup',
  components: { },
  data() {
    return {
      SystemConstants,
      selectTypeNames: TYPE_NAMES,
      operationType: '',
      searchConditions: {
        groupScene: '',
        groupName: '',
        pageNum: 1,
        pageSize: 10,
        total: 4
      },
      gridOptions: {
        rowClassRules: {
          'grid-row-zebra-even': function(params) {
            return !(params.rowIndex % 2)
          },
          'grid-row-zebra-odd': function(params) {
            return (params.rowIndex % 2)
          }
        },
        rowSelection: 'single',
        suppressCellSelection: true,
        defaultColDef: {
          resizable: true,
          filter: true
        },
        pagination: false,
        paginationPageSize: 500,
        context: {
          componentParent: self
        },
        onRowClicked: this.onRowCLick,
        onCellDoubleClicked: this.toLook
      },
      gridParams: {},
      gridApi: null,
      columnDefs: [
        /* {
          headerName: '', width: 55, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },*/
        {
          headerName: this.$t('CargoMsg.Cargo_GroupScene'),
          field: 'groupScene',
          width: 100,
          valueFormatter: (params) => {
            if (params.data.groupSceneTo && params.data.groupSceneCc) {
              return this.$t('CargoMsg.Cargo_Receiver2') + ',' + this.$t('CargoMsg.Cargo_CcPerson')
            } else if (params.data.groupSceneTo) {
              return this.$t('CargoMsg.Cargo_Receiver2')
            } else if (params.data.groupSceneCc) {
              return this.$t('CargoMsg.Cargo_CcPerson')
            }
            return ''
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_GroupType'),
          field: 'groupType',
          width: 100,
          valueFormatter: (params) => {
            if (!params.value && Number(params.value) === 0) {
              return this.$t('CargoMsg.Cargo_Common')
            } else {
              return this.$t('CargoMsg.Cargo_Personal')
            }
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_GroupName'),
          field: 'groupName',
          width: 100
        }, {
          headerName: this.$t('SeaExport.Email'),
          field: 'emailAddress',
          width: 200
        }, {
          headerName: this.$t('CargoMsg.Cargo_Creator'),
          field: 'createdBy',
          width: 100,
          valueFormatter: (params) => {
            if (!params.value) return ''
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('SeaExport.DateOfCreation2'),
          field: 'dateCreated',
          width: 100,
          valueFormatter: (params) => {
            if (!params.value) return ''
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_UpdatePerson'),
          field: 'modifiedBy',
          width: 100,
          valueFormatter: (params) => {
            if (!params.value) return ''
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('SeaExport.UpdateTime'),
          field: 'dateModified',
          width: 100,
          valueFormatter: (params) => {
            if (!params.value) return ''
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        }],
      sideBarDefs: { toolPanels: ['columns', 'filter'], visible: false },
      rowData: [],
      isShowMaintain: false,
      isEdit: false,
      maintainTitle: this.$t('CargoMsg.Cargo_Add'),
      mailGroupForm: {
        uuid: '',
        groupSceneTo: true,
        groupSceneCc: true,
        groupType: 0,
        groupName: '',
        emailAddress: ''
      },
      mailGroupEditForm: {
        uuid: '',
        groupSceneTo: true,
        groupSceneCc: true,
        groupType: 0,
        groupName: '',
        emailAddress: ''
      },
      fullscreenLoading: null
    }
  },
  computed: {
    url() {
      return URL
    }
  },
  created() {
    this.fetchList()
  },
  methods: {
    onGridReady(params) {
      this.gridApi = params.api
      this.gridApi.sizeColumnsToFit()
    },
    // 根据条件进行查询
    fetchList() {
      const self = this
      self.fullscreenLoading = getLoading4Cxt(this)
      const params = { ...this.searchConditions }
      const checkOwner = this.$checkPermission(['role_MailGroup_userSelf']) // 查看自己的数据及公共的数据
      if (checkOwner) params.checkOwner = true
      const checkAll = this.$checkPermission(['role_MailGroup_all']) // 查看全部数据
      if (checkAll) params.checkAll = true
      getMailGroupList(params).then(res => {
        self.rowData = res.data.list
        self.searchConditions.pageNum = res.data.pageNum
        self.searchConditions.pageSize = res.data.pageSize
        self.searchConditions.total = Number(res.data.total)
      }).finally(() => {
        this.mailGroupEditForm = {}
        this.mailGroupForm = {}
        if (this.gridApi) this.gridApi.clearFocusedCell()
        this.fullscreenLoading.close()
      })
    },
    // 行点击事件
    onRowCLick(event) {
      this.mailGroupEditForm = { ...(event.data) }
      this.mailGroupForm = { ...(event.data) }
    },
    // 双击查看
    toLook(event) {
      if (!event.data && !this.mailGroupEditForm.uuid) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      if (!event.data) event = { data: this.mailGroupEditForm } // 点击按钮查看时使用
      this.onRowCLick(event)
      this.maintainTitle = this.$t('CargoMsg.Cargo_View')
      this.isEdit = true
      this.isShowMaintain = true
    },
    // 去新增或编辑
    toSaveOrEdit(isAdd) {
      this.isEdit = false
      if (!isAdd && !this.mailGroupEditForm.uuid) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      if (!isAdd) {
        this.operationType = 'edit'
        this.maintainTitle = this.$t('CargoMsg.Cargo_Edit')
        this.mailGroupForm = { ...(this.mailGroupEditForm) }
      } else {
        this.operationType = 'add'
        this.maintainTitle = this.$t('CargoMsg.Cargo_Add')
        this.mailGroupForm = {
          groupSceneTo: true,
          groupSceneCc: true,
          groupType: 0,
          groupName: '',
          emailAddress: ''
        }
      }
      this.isShowMaintain = true
    },
    // 去删除
    toDelete() {
      if (!this.mailGroupForm.uuid) {
        this.$message.info(this.$t('common.tips.hasOneAtleast'))
        return
      }
      this.$confirm(this.$t('CargoMsg.Cargo_MailGroupDelete'), this.$t('common.tips.confirm'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        this.fullscreenLoading = getLoading4Cxt(this)
        deleteMailGroup(this.mailGroupForm.uuid).then(res => {
          this.mailGroupForm = {}
          this.$message.success(this.$t('common.tips.deleteSuccess'))
        }).then(() => {
          this.fetchList()
        }).finally(() => {
          this.fullscreenLoading.close()
        })
      })
    },
    validate() {
      if (!this.mailGroupForm.groupSceneTo && !this.mailGroupForm.groupSceneCc) {
        // 请至少选择一种类型。
        this.$message.error(this.$t('CargoMsg.Cargo_MailGroupType'))
        return false
      }
      // 请输入群组名称。
      if (!this.mailGroupForm.groupName || !this.mailGroupForm.groupName.trim()) {
        this.$message.error(this.$t('CargoMsg.Cargo_MailGroupName'))
        return false
      }
      // 请输入至少1个邮件地址。
      const emailAddress = this.mailGroupForm.emailAddress
      if (!emailAddress || !emailAddress.trim()) {
        this.$message.error(this.$t('CargoMsg.Cargo_MailGroupEmail'))
        return false
      }
      // 请检查输入的邮件格式。
      const addrArr = emailAddress.split(';')
      if (addrArr && addrArr.length > 0) {
        for (const str of addrArr) {
          if (!str || !str.trim()) continue
          if (str.indexOf('@') < 0 || str.endsWith('@') || str.startsWith('@') ||
            str.indexOf('.') < 0 || str.endsWith('.') || str.startsWith('.')) {
            this.$message.error(this.$t('CargoMsg.Cargo_MailGroupCheckEmail'))
            return false
          }
        }
      }
      return true
    },
    // 保存邮件群组
    saveMailGroup() {
      if (!this.validate()) return
      const params = {
        uuid: this.mailGroupForm.uuid,
        groupSceneTo: this.mailGroupForm.groupSceneTo,
        groupSceneCc: this.mailGroupForm.groupSceneCc,
        groupName: this.mailGroupForm.groupName,
        groupType: this.mailGroupForm.groupType,
        emailAddress: this.mailGroupForm.emailAddress
      }
      this.fullscreenLoading = getLoading4Cxt(this)
      addMailGroup(params).then(res => {
        this.isShowMaintain = false
        this.$message.success(this.$t('common.tips.saveSuccess'))
      }).then(() => {
        this.fetchList()
      }).finally(() => {
        this.fullscreenLoading.close()
      })
    },
    // 编辑邮件群组
    editMailGroup() {
      if (!this.validate()) return
      const params = {
        uuid: this.mailGroupForm.uuid,
        groupSceneTo: this.mailGroupForm.groupSceneTo,
        groupSceneCc: this.mailGroupForm.groupSceneCc,
        groupName: this.mailGroupForm.groupName,
        groupType: this.mailGroupForm.groupType,
        emailAddress: this.mailGroupForm.emailAddress
      }
      this.fullscreenLoading = getLoading4Cxt(this)
      editMailGroup(params).then(res => {
        this.isShowMaintain = false
        this.$message.success(this.$t('common.tips.editSuccess'))
        this.mailGroupEditForm = {}
      }).then(() => {
        this.fetchList()
      }).finally(() => {
        this.fullscreenLoading.close()
      })
    },
    // 保存或者编辑
    saveOrEdit() {
      this.handleAddress()
      if (this.operationType === 'edit') {
        this.editMailGroup()
      } else {
        this.saveMailGroup()
      }
    },
    // 取消保存或者编辑
    cancelSaveOrEdit(isAdd) {
      this.isShowMaintain = false
      if (!isAdd) {
        this.mailGroupEditForm = {}
      } else {
        this.mailGroupForm = {}
      }
    },
    // 处理邮件格式
    handleAddress() {
      let emailAddress = this.mailGroupForm.emailAddress
      if (!emailAddress || !emailAddress.trim()) return
      // 全角转半角
      emailAddress = StrUtils.toHalfword(emailAddress)
      // 将逗号转为分号
      emailAddress = emailAddress.replaceAll(',', ';')
      const strArr = emailAddress.split(';')
      if (strArr && strArr.length > 0) {
        let finalStr = ''
        for (const str of strArr) {
          if (!str || !str.trim()) continue
          finalStr += (str.trim() + ';\n')
        }
        this.mailGroupForm.emailAddress = finalStr.trim()
      }
    }
  }
}
</script>

<style scoped lang="scss">
.lookText{
  white-space: pre-wrap;
}
</style>
